"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChunkListFromRecord = getChunkListFromRecord;
exports.getRecordFromChunkList = getRecordFromChunkList;

var _immutable = require("immutable");

var _Availability = _interopRequireDefault(require("MeetingsBase/models/Availability"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _AvailableTimeChunk = _interopRequireDefault(require("MeetingsBase/models/AvailableTimeChunk"));

function getChunkListFromRecord(availability) {
  return availability.reduce(function (acc, listTimeRanges, day) {
    var timeChunksForDay = listTimeRanges.map(function (timeRange) {
      return new _AvailableTimeChunk.default({
        day: day,
        startMinute: timeRange.start,
        endMinute: timeRange.end
      });
    });
    return acc.concat(timeChunksForDay);
  }, (0, _immutable.List)());
}

function getRecordFromChunkList(availableTimeChunks) {
  return availableTimeChunks.reduce(function (acc, timeChunk) {
    return acc.update(timeChunk.day, function (timeChunksForDay) {
      return timeChunksForDay.push(_TimeRange.default.from({
        start: timeChunk.startMinute,
        end: timeChunk.endMinute
      }));
    });
  }, new _Availability.default());
}